import { v4 } from 'uuid';
import { useIntegratedActionBroadcaster } from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useBroadcast } from '../broadcast-channel/use-broadcast';
import { useApplicationType } from './use-application-type';

export function useOpenUnitStatusSearch() {
    const { trigger } = useIntegratedActionBroadcaster();
    const { postMessage } = useBroadcast('legacy-store-broadcast');
    const { isCadElectronRewrite, isCadWeb, isCadLegacyElectron } = useApplicationType();
    const openUnitStatusSearch = () => {
        if (isCadElectronRewrite || isCadWeb) {
            trigger([
                {
                    id: v4(),
                    targetWindowType: 'ROOT',
                    type: 'OPEN_UNIT_STATUS_SEARCH_V2_WINDOW',
                },
            ]);
        } else if (isCadLegacyElectron) {
            postMessage({ type: 'OPEN_UNIT_STATUS_SEARCH_V2_WINDOW' });
        }
    };
    return openUnitStatusSearch;
}
